/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Logoalt1Inputs */

const id_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const ms_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const da_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const de_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const en_us2_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const es_es2_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de EGDATA`)
};

const es_mx2_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de EGDATA`)
};

const fil_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo ng EGDATA`)
};

const fr_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const it_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const hu_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA logó`)
};

const nl_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const no_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-logo`)
};

const pl_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const pt_br2_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo do EGDATA`)
};

const pt_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logótipo EGDATA`)
};

const ro_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const fi_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-logo`)
};

const sv_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-logotyp`)
};

const vi_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const tr_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logosu`)
};

const cs_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo EGDATA`)
};

const bg_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лого на EGDATA`)
};

const ru_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип EGDATA`)
};

const uk_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип EGDATA`)
};

const ar_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شعار EGDATA`)
};

const hi_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA लोगो`)
};

const th_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โลโก้ EGDATA`)
};

const ja_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA ロゴ`)
};

const zh_cn2_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const zh_hant1_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Logo`)
};

const ko_footer_logoalt1 = /** @type {(inputs: Footer_Logoalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA 로고`)
};

/**
* | output |
* | --- |
* | "EGDATA Logo" |
*
* @param {Footer_Logoalt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_logoalt1 = /** @type {((inputs?: Footer_Logoalt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Logoalt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_logoalt1(inputs)
	if (locale === "ms") return ms_footer_logoalt1(inputs)
	if (locale === "da") return da_footer_logoalt1(inputs)
	if (locale === "de") return de_footer_logoalt1(inputs)
	if (locale === "en-US") return en_us2_footer_logoalt1(inputs)
	if (locale === "es-ES") return es_es2_footer_logoalt1(inputs)
	if (locale === "es-MX") return es_mx2_footer_logoalt1(inputs)
	if (locale === "fil") return fil_footer_logoalt1(inputs)
	if (locale === "fr") return fr_footer_logoalt1(inputs)
	if (locale === "it") return it_footer_logoalt1(inputs)
	if (locale === "hu") return hu_footer_logoalt1(inputs)
	if (locale === "nl") return nl_footer_logoalt1(inputs)
	if (locale === "no") return no_footer_logoalt1(inputs)
	if (locale === "pl") return pl_footer_logoalt1(inputs)
	if (locale === "pt-BR") return pt_br2_footer_logoalt1(inputs)
	if (locale === "pt") return pt_footer_logoalt1(inputs)
	if (locale === "ro") return ro_footer_logoalt1(inputs)
	if (locale === "fi") return fi_footer_logoalt1(inputs)
	if (locale === "sv") return sv_footer_logoalt1(inputs)
	if (locale === "vi") return vi_footer_logoalt1(inputs)
	if (locale === "tr") return tr_footer_logoalt1(inputs)
	if (locale === "cs") return cs_footer_logoalt1(inputs)
	if (locale === "bg") return bg_footer_logoalt1(inputs)
	if (locale === "ru") return ru_footer_logoalt1(inputs)
	if (locale === "uk") return uk_footer_logoalt1(inputs)
	if (locale === "ar") return ar_footer_logoalt1(inputs)
	if (locale === "hi") return hi_footer_logoalt1(inputs)
	if (locale === "th") return th_footer_logoalt1(inputs)
	if (locale === "ja") return ja_footer_logoalt1(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_logoalt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_logoalt1(inputs)
	return ko_footer_logoalt1(inputs)
});
export { footer_logoalt1 as "footer.logoAlt" }